import { useState, useMemo } from "react";
import { Modal, TextInput, SimpleGrid, UnstyledButton, Text, Stack, ScrollArea, Group, Badge } from "@mantine/core";
import { Search } from "lucide-react";
import { HexIcon } from "@/components/HexIcon";
import classes from "./IconPickerModal.module.css";

// Complete list of Lucide icon names (1500+ icons)
const LUCIDE_ICONS = [
  "a-arrow-down",
  "a-arrow-up",
  "a-large-small",
  "accessibility",
  "activity",
  "activity-square",
  "air-vent",
  "airplay",
  "alarm-check",
  "alarm-clock",
  "alarm-clock-check",
  "alarm-clock-minus",
  "alarm-clock-off",
  "alarm-clock-plus",
  "alarm-minus",
  "alarm-plus",
  "alarm-smoke",
  "album",
  "alert-circle",
  "alert-octagon",
  "alert-triangle",
  "align-center",
  "align-center-horizontal",
  "align-center-vertical",
  "align-end-horizontal",
  "align-end-vertical",
  "align-horizontal-distribute-center",
  "align-horizontal-distribute-end",
  "align-horizontal-distribute-start",
  "align-horizontal-justify-center",
  "align-horizontal-justify-end",
  "align-horizontal-justify-start",
  "align-horizontal-space-around",
  "align-horizontal-space-between",
  "align-justify",
  "align-left",
  "align-right",
  "align-start-horizontal",
  "align-start-vertical",
  "align-vertical-distribute-center",
  "align-vertical-distribute-end",
  "align-vertical-distribute-start",
  "align-vertical-justify-center",
  "align-vertical-justify-end",
  "align-vertical-justify-start",
  "align-vertical-space-around",
  "align-vertical-space-between",
  "ambulance",
  "ampersand",
  "ampersands",
  "amphora",
  "anchor",
  "angry",
  "annoyed",
  "antenna",
  "anvil",
  "aperture",
  "app-window",
  "app-window-mac",
  "apple",
  "archive",
  "archive-restore",
  "archive-x",
  "area-chart",
  "armchair",
  "arrow-big-down",
  "arrow-big-down-dash",
  "arrow-big-left",
  "arrow-big-left-dash",
  "arrow-big-right",
  "arrow-big-right-dash",
  "arrow-big-up",
  "arrow-big-up-dash",
  "arrow-down",
  "arrow-down-az",
  "arrow-down-circle",
  "arrow-down-from-line",
  "arrow-down-left",
  "arrow-down-left-from-circle",
  "arrow-down-left-from-square",
  "arrow-down-left-square",
  "arrow-down-narrow-wide",
  "arrow-down-right",
  "arrow-down-right-from-circle",
  "arrow-down-right-from-square",
  "arrow-down-right-square",
  "arrow-down-square",
  "arrow-down-to-dot",
  "arrow-down-to-line",
  "arrow-down-up",
  "arrow-down-wide-narrow",
  "arrow-down-za",
  "arrow-down01",
  "arrow-down10",
  "arrow-left",
  "arrow-left-circle",
  "arrow-left-from-line",
  "arrow-left-right",
  "arrow-left-square",
  "arrow-left-to-line",
  "arrow-right",
  "arrow-right-circle",
  "arrow-right-from-line",
  "arrow-right-left",
  "arrow-right-square",
  "arrow-right-to-line",
  "arrow-up",
  "arrow-up-az",
  "arrow-up-circle",
  "arrow-up-down",
  "arrow-up-from-dot",
  "arrow-up-from-line",
  "arrow-up-left",
  "arrow-up-left-from-circle",
  "arrow-up-left-from-square",
  "arrow-up-left-square",
  "arrow-up-narrow-wide",
  "arrow-up-right",
  "arrow-up-right-from-circle",
  "arrow-up-right-from-square",
  "arrow-up-right-square",
  "arrow-up-square",
  "arrow-up-to-line",
  "arrow-up-wide-narrow",
  "arrow-up-za",
  "arrow-up01",
  "arrow-up10",
  "arrows-up-from-line",
  "asterisk",
  "asterisk-square",
  "at-sign",
  "atom",
  "audio-lines",
  "audio-waveform",
  "award",
  "axe",
  "axis3d",
  "baby",
  "backpack",
  "badge",
  "badge-alert",
  "badge-cent",
  "badge-check",
  "badge-dollar-sign",
  "badge-euro",
  "badge-help",
  "badge-indian-rupee",
  "badge-info",
  "badge-japanese-yen",
  "badge-minus",
  "badge-percent",
  "badge-plus",
  "badge-pound-sterling",
  "badge-russian-ruble",
  "badge-swiss-franc",
  "badge-x",
  "baggage-claim",
  "ban",
  "banana",
  "bandage",
  "banknote",
  "bar-chart",
  "bar-chart-big",
  "bar-chart-horizontal",
  "bar-chart-horizontal-big",
  "bar-chart2",
  "bar-chart3",
  "bar-chart4",
  "barcode",
  "baseline",
  "bath",
  "battery",
  "battery-charging",
  "battery-full",
  "battery-low",
  "battery-medium",
  "battery-warning",
  "beaker",
  "bean",
  "bean-off",
  "bed",
  "bed-double",
  "bed-single",
  "beef",
  "beer",
  "beer-off",
  "bell",
  "bell-dot",
  "bell-electric",
  "bell-minus",
  "bell-off",
  "bell-plus",
  "bell-ring",
  "between-horizonal-end",
  "between-horizonal-start",
  "between-horizontal-end",
  "between-horizontal-start",
  "between-vertical-end",
  "between-vertical-start",
  "biceps-flexed",
  "bike",
  "binary",
  "binoculars",
  "biohazard",
  "bird",
  "bitcoin",
  "blend",
  "blinds",
  "blocks",
  "bluetooth",
  "bluetooth-connected",
  "bluetooth-off",
  "bluetooth-searching",
  "bold",
  "bolt",
  "bomb",
  "bone",
  "book",
  "book-a",
  "book-audio",
  "book-check",
  "book-copy",
  "book-dashed",
  "book-down",
  "book-headphones",
  "book-heart",
  "book-image",
  "book-key",
  "book-lock",
  "book-marked",
  "book-minus",
  "book-open",
  "book-open-check",
  "book-open-text",
  "book-plus",
  "book-template",
  "book-text",
  "book-type",
  "book-up",
  "book-up2",
  "book-user",
  "book-x",
  "bookmark",
  "bookmark-check",
  "bookmark-minus",
  "bookmark-plus",
  "bookmark-x",
  "boom-box",
  "bot",
  "bot-message-square",
  "bot-off",
  "box",
  "box-select",
  "boxes",
  "braces",
  "brackets",
  "brain",
  "brain-circuit",
  "brain-cog",
  "brick-wall",
  "briefcase",
  "briefcase-business",
  "briefcase-conveyor-belt",
  "briefcase-medical",
  "bring-to-front",
  "brush",
  "bug",
  "bug-off",
  "bug-play",
  "building",
  "building2",
  "bus",
  "bus-front",
  "cable",
  "cable-car",
  "cake",
  "cake-slice",
  "calculator",
  "calendar",
  "calendar-arrow-down",
  "calendar-arrow-up",
  "calendar-check",
  "calendar-check2",
  "calendar-clock",
  "calendar-cog",
  "calendar-days",
  "calendar-fold",
  "calendar-heart",
  "calendar-minus",
  "calendar-minus2",
  "calendar-off",
  "calendar-plus",
  "calendar-plus2",
  "calendar-range",
  "calendar-search",
  "calendar-sync",
  "calendar-x",
  "calendar-x2",
  "calendar1",
  "camera",
  "camera-off",
  "candlestick-chart",
  "candy",
  "candy-cane",
  "candy-off",
  "cannabis",
  "captions",
  "captions-off",
  "car",
  "car-front",
  "car-taxi-front",
  "caravan",
  "carrot",
  "case-lower",
  "case-sensitive",
  "case-upper",
  "cassette-tape",
  "cast",
  "castle",
  "cat",
  "cctv",
  "chart-area",
  "chart-bar",
  "chart-bar-big",
  "chart-bar-decreasing",
  "chart-bar-increasing",
  "chart-bar-stacked",
  "chart-candlestick",
  "chart-column",
  "chart-column-big",
  "chart-column-decreasing",
  "chart-column-increasing",
  "chart-column-stacked",
  "chart-gantt",
  "chart-line",
  "chart-network",
  "chart-no-axes-column",
  "chart-no-axes-column-decreasing",
  "chart-no-axes-column-increasing",
  "chart-no-axes-combined",
  "chart-no-axes-gantt",
  "chart-pie",
  "chart-scatter",
  "chart-spline",
  "check",
  "check-check",
  "check-circle",
  "check-circle2",
  "check-square",
  "check-square2",
  "chef-hat",
  "cherry",
  "chevron-down",
  "chevron-down-circle",
  "chevron-down-square",
  "chevron-first",
  "chevron-last",
  "chevron-left",
  "chevron-left-circle",
  "chevron-left-square",
  "chevron-right",
  "chevron-right-circle",
  "chevron-right-square",
  "chevron-up",
  "chevron-up-circle",
  "chevron-up-square",
  "chevrons-down",
  "chevrons-down-up",
  "chevrons-left",
  "chevrons-left-right",
  "chevrons-left-right-ellipsis",
  "chevrons-right",
  "chevrons-right-left",
  "chevrons-up",
  "chevrons-up-down",
  "chrome",
  "church",
  "cigarette",
  "cigarette-off",
  "circle",
  "circle-alert",
  "circle-arrow-down",
  "circle-arrow-left",
  "circle-arrow-out-down-left",
  "circle-arrow-out-down-right",
  "circle-arrow-out-up-left",
  "circle-arrow-out-up-right",
  "circle-arrow-right",
  "circle-arrow-up",
  "circle-check",
  "circle-check-big",
  "circle-chevron-down",
  "circle-chevron-left",
  "circle-chevron-right",
  "circle-chevron-up",
  "circle-dashed",
  "circle-divide",
  "circle-dollar-sign",
  "circle-dot",
  "circle-dot-dashed",
  "circle-ellipsis",
  "circle-equal",
  "circle-fading-arrow-up",
  "circle-fading-plus",
  "circle-gauge",
  "circle-help",
  "circle-minus",
  "circle-off",
  "circle-parking",
  "circle-parking-off",
  "circle-pause",
  "circle-percent",
  "circle-play",
  "circle-plus",
  "circle-power",
  "circle-slash",
  "circle-slash2",
  "circle-slashed",
  "circle-stop",
  "circle-user",
  "circle-user-round",
  "circle-x",
  "circuit-board",
  "citrus",
  "clapperboard",
  "clipboard",
  "clipboard-check",
  "clipboard-copy",
  "clipboard-edit",
  "clipboard-list",
  "clipboard-minus",
  "clipboard-paste",
  "clipboard-pen",
  "clipboard-pen-line",
  "clipboard-plus",
  "clipboard-signature",
  "clipboard-type",
  "clipboard-x",
  "clock",
  "clock-alert",
  "clock-arrow-down",
  "clock-arrow-up",
  "clock1",
  "clock10",
  "clock11",
  "clock12",
  "clock2",
  "clock3",
  "clock4",
  "clock5",
  "clock6",
  "clock7",
  "clock8",
  "clock9",
  "cloud",
  "cloud-alert",
  "cloud-cog",
  "cloud-download",
  "cloud-drizzle",
  "cloud-fog",
  "cloud-hail",
  "cloud-lightning",
  "cloud-moon",
  "cloud-moon-rain",
  "cloud-off",
  "cloud-rain",
  "cloud-rain-wind",
  "cloud-snow",
  "cloud-sun",
  "cloud-sun-rain",
  "cloud-upload",
  "cloudy",
  "clover",
  "club",
  "code",
  "code-square",
  "code-xml",
  "code2",
  "codepen",
  "codesandbox",
  "coffee",
  "cog",
  "coins",
  "columns",
  "columns2",
  "columns3",
  "columns4",
  "combine",
  "command",
  "compass",
  "component",
  "computer",
  "concierge-bell",
  "cone",
  "construction",
  "contact",
  "contact-round",
  "contact2",
  "container",
  "contrast",
  "cookie",
  "cooking-pot",
  "copy",
  "copy-check",
  "copy-minus",
  "copy-plus",
  "copy-slash",
  "copy-x",
  "copyleft",
  "copyright",
  "corner-down-left",
  "corner-down-right",
  "corner-left-down",
  "corner-left-up",
  "corner-right-down",
  "corner-right-up",
  "corner-up-left",
  "corner-up-right",
  "cpu",
  "creative-commons",
  "credit-card",
  "croissant",
  "crop",
  "cross",
  "crosshair",
  "crown",
  "cuboid",
  "cup-soda",
  "curly-braces",
  "currency",
  "cylinder",
  "dam",
  "database",
  "database-backup",
  "database-zap",
  "delete",
  "dessert",
  "diameter",
  "diamond",
  "diamond-minus",
  "diamond-percent",
  "diamond-plus",
  "dice1",
  "dice2",
  "dice3",
  "dice4",
  "dice5",
  "dice6",
  "dices",
  "diff",
  "disc",
  "disc-album",
  "disc2",
  "disc3",
  "divide",
  "divide-circle",
  "divide-square",
  "dna",
  "dna-off",
  "dock",
  "dog",
  "dollar-sign",
  "donut",
  "door-closed",
  "door-open",
  "dot",
  "dot-square",
  "download",
  "download-cloud",
  "drafting-compass",
  "drama",
  "dribbble",
  "drill",
  "droplet",
  "droplet-off",
  "droplets",
  "drum",
  "drumstick",
  "dumbbell",
  "ear",
  "ear-off",
  "earth",
  "earth-lock",
  "eclipse",
  "edit",
  "edit2",
  "edit3",
  "egg",
  "egg-fried",
  "egg-off",
  "ellipsis",
  "ellipsis-vertical",
  "equal",
  "equal-approximately",
  "equal-not",
  "equal-square",
  "eraser",
  "ethernet-port",
  "euro",
  "expand",
  "external-link",
  "eye",
  "eye-closed",
  "eye-off",
  "facebook",
  "factory",
  "fan",
  "fast-forward",
  "feather",
  "fence",
  "ferris-wheel",
  "figma",
  "file",
  "file-archive",
  "file-audio",
  "file-audio2",
  "file-axis3d",
  "file-badge",
  "file-badge2",
  "file-bar-chart",
  "file-bar-chart2",
  "file-box",
  "file-chart-column",
  "file-chart-column-increasing",
  "file-chart-line",
  "file-chart-pie",
  "file-check",
  "file-check2",
  "file-clock",
  "file-code",
  "file-code2",
  "file-cog",
  "file-cog2",
  "file-diff",
  "file-digit",
  "file-down",
  "file-edit",
  "file-heart",
  "file-image",
  "file-input",
  "file-json",
  "file-json2",
  "file-key",
  "file-key2",
  "file-line-chart",
  "file-lock",
  "file-lock2",
  "file-minus",
  "file-minus2",
  "file-music",
  "file-output",
  "file-pen",
  "file-pen-line",
  "file-pie-chart",
  "file-plus",
  "file-plus2",
  "file-question",
  "file-scan",
  "file-search",
  "file-search2",
  "file-signature",
  "file-sliders",
  "file-spreadsheet",
  "file-stack",
  "file-symlink",
  "file-terminal",
  "file-text",
  "file-type",
  "file-type2",
  "file-up",
  "file-user",
  "file-video",
  "file-video2",
  "file-volume",
  "file-volume2",
  "file-warning",
  "file-x",
  "file-x2",
  "files",
  "film",
  "filter",
  "filter-x",
  "fingerprint",
  "fire-extinguisher",
  "fish",
  "fish-off",
  "fish-symbol",
  "flag",
  "flag-off",
  "flag-triangle-left",
  "flag-triangle-right",
  "flame",
  "flame-kindling",
  "flashlight",
  "flashlight-off",
  "flask-conical",
  "flask-conical-off",
  "flask-round",
  "flip-horizontal",
  "flip-horizontal2",
  "flip-vertical",
  "flip-vertical2",
  "flower",
  "flower2",
  "focus",
  "fold-horizontal",
  "fold-vertical",
  "folder",
  "folder-archive",
  "folder-check",
  "folder-clock",
  "folder-closed",
  "folder-code",
  "folder-cog",
  "folder-cog2",
  "folder-dot",
  "folder-down",
  "folder-edit",
  "folder-git",
  "folder-git2",
  "folder-heart",
  "folder-input",
  "folder-kanban",
  "folder-key",
  "folder-lock",
  "folder-minus",
  "folder-open",
  "folder-open-dot",
  "folder-output",
  "folder-pen",
  "folder-plus",
  "folder-root",
  "folder-search",
  "folder-search2",
  "folder-symlink",
  "folder-sync",
  "folder-tree",
  "folder-up",
  "folder-x",
  "folders",
  "footprints",
  "fork-knife",
  "fork-knife-crossed",
  "forklift",
  "form-input",
  "forward",
  "frame",
  "framer",
  "frown",
  "fuel",
  "fullscreen",
  "function-square",
  "gallery-horizontal",
  "gallery-horizontal-end",
  "gallery-thumbnails",
  "gallery-vertical",
  "gallery-vertical-end",
  "gamepad",
  "gamepad2",
  "gantt-chart",
  "gantt-chart-square",
  "gauge",
  "gauge-circle",
  "gavel",
  "gem",
  "ghost",
  "gift",
  "git-branch",
  "git-branch-plus",
  "git-commit",
  "git-commit-horizontal",
  "git-commit-vertical",
  "git-compare",
  "git-compare-arrows",
  "git-fork",
  "git-graph",
  "git-merge",
  "git-pull-request",
  "git-pull-request-arrow",
  "git-pull-request-closed",
  "git-pull-request-create",
  "git-pull-request-create-arrow",
  "git-pull-request-draft",
  "github",
  "gitlab",
  "glass-water",
  "glasses",
  "globe",
  "globe-lock",
  "globe2",
  "goal",
  "grab",
  "graduation-cap",
  "grape",
  "grid",
  "grid2x2",
  "grid2x2check",
  "grid2x2plus",
  "grid2x2x",
  "grid3x3",
  "grip",
  "grip-horizontal",
  "grip-vertical",
  "group",
  "guitar",
  "ham",
  "hammer",
  "hand",
  "hand-coins",
  "hand-heart",
  "hand-helping",
  "hand-metal",
  "hand-platter",
  "handshake",
  "hard-drive",
  "hard-drive-download",
  "hard-drive-upload",
  "hard-hat",
  "hash",
  "haze",
  "hdmi-port",
  "heading",
  "heading1",
  "heading2",
  "heading3",
  "heading4",
  "heading5",
  "heading6",
  "headphone-off",
  "headphones",
  "headset",
  "heart",
  "heart-crack",
  "heart-handshake",
  "heart-off",
  "heart-pulse",
  "heater",
  "help-circle",
  "helping-hand",
  "hexagon",
  "highlighter",
  "history",
  "home",
  "hop",
  "hop-off",
  "hospital",
  "hotel",
  "hourglass",
  "house",
  "house-plug",
  "house-plus",
  "ice-cream",
  "ice-cream-bowl",
  "ice-cream-cone",
  "ice-cream2",
  "id-card",
  "image",
  "image-down",
  "image-minus",
  "image-off",
  "image-play",
  "image-plus",
  "image-up",
  "image-upscale",
  "images",
  "import",
  "inbox",
  "indent",
  "indent-decrease",
  "indent-increase",
  "indian-rupee",
  "infinity",
  "info",
  "inspect",
  "inspection-panel",
  "instagram",
  "italic",
  "iteration-ccw",
  "iteration-cw",
  "japanese-yen",
  "joystick",
  "kanban",
  "kanban-square",
  "kanban-square-dashed",
  "key",
  "key-round",
  "key-square",
  "keyboard",
  "keyboard-music",
  "keyboard-off",
  "lamp",
  "lamp-ceiling",
  "lamp-desk",
  "lamp-floor",
  "lamp-wall-down",
  "lamp-wall-up",
  "land-plot",
  "landmark",
  "languages",
  "laptop",
  "laptop-minimal",
  "laptop-minimal-check",
  "laptop2",
  "lasso",
  "lasso-select",
  "laugh",
  "layers",
  "layers2",
  "layers3",
  "layout",
  "layout-dashboard",
  "layout-grid",
  "layout-list",
  "layout-panel-left",
  "layout-panel-top",
  "layout-template",
  "leaf",
  "leafy-green",
  "lectern",
  "letter-text",
  "library",
  "library-big",
  "library-square",
  "life-buoy",
  "ligature",
  "lightbulb",
  "lightbulb-off",
  "line-chart",
  "link",
  "link2",
  "link2off",
  "linkedin",
  "list",
  "list-check",
  "list-checks",
  "list-collapse",
  "list-end",
  "list-filter",
  "list-filter-plus",
  "list-minus",
  "list-music",
  "list-ordered",
  "list-plus",
  "list-restart",
  "list-start",
  "list-todo",
  "list-tree",
  "list-video",
  "list-x",
  "loader",
  "loader-circle",
  "loader-pinwheel",
  "loader2",
  "locate",
  "locate-fixed",
  "locate-off",
  "lock",
  "lock-keyhole",
  "lock-keyhole-open",
  "lock-open",
  "log-in",
  "log-out",
  "logs",
  "lollipop",
  "luggage",
  "m-square",
  "magnet",
  "mail",
  "mail-check",
  "mail-minus",
  "mail-open",
  "mail-plus",
  "mail-question",
  "mail-search",
  "mail-warning",
  "mail-x",
  "mailbox",
  "mails",
  "map",
  "map-pin",
  "map-pin-check",
  "map-pin-check-inside",
  "map-pin-house",
  "map-pin-minus",
  "map-pin-minus-inside",
  "map-pin-off",
  "map-pin-plus",
  "map-pin-plus-inside",
  "map-pin-x",
  "map-pin-x-inside",
  "map-pinned",
  "martini",
  "maximize",
  "maximize2",
  "medal",
  "megaphone",
  "megaphone-off",
  "meh",
  "memory-stick",
  "menu",
  "menu-square",
  "merge",
  "message-circle",
  "message-circle-code",
  "message-circle-dashed",
  "message-circle-heart",
  "message-circle-more",
  "message-circle-off",
  "message-circle-plus",
  "message-circle-question",
  "message-circle-reply",
  "message-circle-warning",
  "message-circle-x",
  "message-square",
  "message-square-code",
  "message-square-dashed",
  "message-square-diff",
  "message-square-dot",
  "message-square-heart",
  "message-square-lock",
  "message-square-more",
  "message-square-off",
  "message-square-plus",
  "message-square-quote",
  "message-square-reply",
  "message-square-share",
  "message-square-text",
  "message-square-warning",
  "message-square-x",
  "messages-square",
  "mic",
  "mic-off",
  "mic-vocal",
  "mic2",
  "microchip",
  "microscope",
  "microwave",
  "milestone",
  "milk",
  "milk-off",
  "minimize",
  "minimize2",
  "minus",
  "minus-circle",
  "minus-square",
  "monitor",
  "monitor-check",
  "monitor-cog",
  "monitor-dot",
  "monitor-down",
  "monitor-off",
  "monitor-pause",
  "monitor-play",
  "monitor-smartphone",
  "monitor-speaker",
  "monitor-stop",
  "monitor-up",
  "monitor-x",
  "moon",
  "moon-star",
  "more-horizontal",
  "more-vertical",
  "mountain",
  "mountain-snow",
  "mouse",
  "mouse-off",
  "mouse-pointer",
  "mouse-pointer-ban",
  "mouse-pointer-click",
  "mouse-pointer-square-dashed",
  "mouse-pointer2",
  "move",
  "move-diagonal",
  "move-diagonal2",
  "move-down",
  "move-down-left",
  "move-down-right",
  "move-horizontal",
  "move-left",
  "move-right",
  "move-up",
  "move-up-left",
  "move-up-right",
  "move-vertical",
  "move3d",
  "music",
  "music2",
  "music3",
  "music4",
  "navigation",
  "navigation-off",
  "navigation2",
  "navigation2off",
  "network",
  "newspaper",
  "nfc",
  "notebook",
  "notebook-pen",
  "notebook-tabs",
  "notebook-text",
  "notepad-text",
  "notepad-text-dashed",
  "nut",
  "nut-off",
  "octagon",
  "octagon-alert",
  "octagon-minus",
  "octagon-pause",
  "octagon-x",
  "omega",
  "option",
  "orbit",
  "origami",
  "outdent",
  "package",
  "package-check",
  "package-minus",
  "package-open",
  "package-plus",
  "package-search",
  "package-x",
  "package2",
  "paint-bucket",
  "paint-roller",
  "paintbrush",
  "paintbrush-vertical",
  "paintbrush2",
  "palette",
  "palmtree",
  "panel-bottom",
  "panel-bottom-close",
  "panel-bottom-dashed",
  "panel-bottom-inactive",
  "panel-bottom-open",
  "panel-left",
  "panel-left-close",
  "panel-left-dashed",
  "panel-left-inactive",
  "panel-left-open",
  "panel-right",
  "panel-right-close",
  "panel-right-dashed",
  "panel-right-inactive",
  "panel-right-open",
  "panel-top",
  "panel-top-close",
  "panel-top-dashed",
  "panel-top-inactive",
  "panel-top-open",
  "panels-left-bottom",
  "panels-left-right",
  "panels-right-bottom",
  "panels-top-bottom",
  "panels-top-left",
  "paperclip",
  "parentheses",
  "parking-circle",
  "parking-circle-off",
  "parking-meter",
  "parking-square",
  "parking-square-off",
  "party-popper",
  "pause",
  "pause-circle",
  "pause-octagon",
  "paw-print",
  "pc-case",
  "pen",
  "pen-box",
  "pen-line",
  "pen-off",
  "pen-square",
  "pen-tool",
  "pencil",
  "pencil-line",
  "pencil-off",
  "pencil-ruler",
  "pentagon",
  "percent",
  "percent-circle",
  "percent-diamond",
  "percent-square",
  "person-standing",
  "philippine-peso",
  "phone",
  "phone-call",
  "phone-forwarded",
  "phone-incoming",
  "phone-missed",
  "phone-off",
  "phone-outgoing",
  "pi",
  "pi-square",
  "piano",
  "pickaxe",
  "picture-in-picture",
  "picture-in-picture2",
  "pie-chart",
  "piggy-bank",
  "pilcrow",
  "pilcrow-left",
  "pilcrow-right",
  "pilcrow-square",
  "pill",
  "pill-bottle",
  "pin",
  "pin-off",
  "pipette",
  "pizza",
  "plane",
  "plane-landing",
  "plane-takeoff",
  "play",
  "play-circle",
  "play-square",
  "plug",
  "plug-zap",
  "plug-zap2",
  "plug2",
  "plus",
  "plus-circle",
  "plus-square",
  "pocket",
  "pocket-knife",
  "podcast",
  "pointer",
  "pointer-off",
  "popcorn",
  "popsicle",
  "pound-sterling",
  "power",
  "power-circle",
  "power-off",
  "power-square",
  "presentation",
  "printer",
  "printer-check",
  "projector",
  "proportions",
  "puzzle",
  "pyramid",
  "qr-code",
  "quote",
  "rabbit",
  "radar",
  "radiation",
  "radical",
  "radio",
  "radio-receiver",
  "radio-tower",
  "radius",
  "rail-symbol",
  "rainbow",
  "rat",
  "ratio",
  "receipt",
  "receipt-cent",
  "receipt-euro",
  "receipt-indian-rupee",
  "receipt-japanese-yen",
  "receipt-pound-sterling",
  "receipt-russian-ruble",
  "receipt-swiss-franc",
  "receipt-text",
  "rectangle-ellipsis",
  "rectangle-horizontal",
  "rectangle-vertical",
  "recycle",
  "redo",
  "redo-dot",
  "redo2",
  "refresh-ccw",
  "refresh-ccw-dot",
  "refresh-cw",
  "refresh-cw-off",
  "refrigerator",
  "regex",
  "remove-formatting",
  "repeat",
  "repeat1",
  "repeat2",
  "replace",
  "replace-all",
  "reply",
  "reply-all",
  "rewind",
  "ribbon",
  "rocket",
  "rocking-chair",
  "roller-coaster",
  "rotate-ccw",
  "rotate-ccw-square",
  "rotate-cw",
  "rotate-cw-square",
  "rotate3d",
  "route",
  "route-off",
  "router",
  "rows",
  "rows2",
  "rows3",
  "rows4",
  "rss",
  "ruler",
  "russian-ruble",
  "sailboat",
  "salad",
  "sandwich",
  "satellite",
  "satellite-dish",
  "save",
  "save-all",
  "save-off",
  "scale",
  "scale3d",
  "scaling",
  "scan",
  "scan-barcode",
  "scan-eye",
  "scan-face",
  "scan-heart",
  "scan-line",
  "scan-qr-code",
  "scan-search",
  "scan-text",
  "scatter-chart",
  "school",
  "school2",
  "scissors",
  "scissors-line-dashed",
  "scissors-square",
  "scissors-square-dashed-bottom",
  "screen-share",
  "screen-share-off",
  "scroll",
  "scroll-text",
  "search",
  "search-check",
  "search-code",
  "search-slash",
  "search-x",
  "section",
  "send",
  "send-horizonal",
  "send-horizontal",
  "send-to-back",
  "separator-horizontal",
  "separator-vertical",
  "server",
  "server-cog",
  "server-crash",
  "server-off",
  "settings",
  "settings2",
  "shapes",
  "share",
  "share2",
  "sheet",
  "shell",
  "shield",
  "shield-alert",
  "shield-ban",
  "shield-check",
  "shield-close",
  "shield-ellipsis",
  "shield-half",
  "shield-minus",
  "shield-off",
  "shield-plus",
  "shield-question",
  "shield-x",
  "ship",
  "ship-wheel",
  "shirt",
  "shopping-bag",
  "shopping-basket",
  "shopping-cart",
  "shovel",
  "shower-head",
  "shrink",
  "shrub",
  "shuffle",
  "sidebar",
  "sidebar-close",
  "sidebar-open",
  "sigma",
  "sigma-square",
  "signal",
  "signal-high",
  "signal-low",
  "signal-medium",
  "signal-zero",
  "signature",
  "signpost",
  "signpost-big",
  "siren",
  "skip-back",
  "skip-forward",
  "skull",
  "slack",
  "slash",
  "slash-square",
  "slice",
  "sliders",
  "sliders-horizontal",
  "sliders-vertical",
  "smartphone",
  "smartphone-charging",
  "smartphone-nfc",
  "smile",
  "smile-plus",
  "snail",
  "snowflake",
  "sofa",
  "sort-asc",
  "sort-desc",
  "soup",
  "space",
  "spade",
  "sparkle",
  "sparkles",
  "speaker",
  "speech",
  "spell-check",
  "spell-check2",
  "spline",
  "split",
  "split-square-horizontal",
  "split-square-vertical",
  "spray-can",
  "sprout",
  "square",
  "square-activity",
  "square-arrow-down",
  "square-arrow-down-left",
  "square-arrow-down-right",
  "square-arrow-left",
  "square-arrow-out-down-left",
  "square-arrow-out-down-right",
  "square-arrow-out-up-left",
  "square-arrow-out-up-right",
  "square-arrow-right",
  "square-arrow-up",
  "square-arrow-up-left",
  "square-arrow-up-right",
  "square-asterisk",
  "square-bottom-dashed-scissors",
  "square-chart-gantt",
  "square-check",
  "square-check-big",
  "square-chevron-down",
  "square-chevron-left",
  "square-chevron-right",
  "square-chevron-up",
  "square-code",
  "square-dashed",
  "square-dashed-bottom",
  "square-dashed-bottom-code",
  "square-dashed-kanban",
  "square-dashed-mouse-pointer",
  "square-divide",
  "square-dot",
  "square-equal",
  "square-function",
  "square-gantt-chart",
  "square-kanban",
  "square-library",
  "square-m",
  "square-menu",
  "square-minus",
  "square-mouse-pointer",
  "square-parking",
  "square-parking-off",
  "square-pen",
  "square-percent",
  "square-pi",
  "square-pilcrow",
  "square-play",
  "square-plus",
  "square-power",
  "square-radical",
  "square-scissors",
  "square-sigma",
  "square-slash",
  "square-split-horizontal",
  "square-split-vertical",
  "square-square",
  "square-stack",
  "square-terminal",
  "square-user",
  "square-user-round",
  "square-x",
  "squircle",
  "squirrel",
  "stamp",
  "star",
  "star-half",
  "star-off",
  "stars",
  "step-back",
  "step-forward",
  "stethoscope",
  "sticker",
  "sticky-note",
  "stop-circle",
  "store",
  "stretch-horizontal",
  "stretch-vertical",
  "strikethrough",
  "subscript",
  "subtitles",
  "sun",
  "sun-dim",
  "sun-medium",
  "sun-moon",
  "sun-snow",
  "sunrise",
  "sunset",
  "superscript",
  "swatch-book",
  "swiss-franc",
  "switch-camera",
  "sword",
  "swords",
  "syringe",
  "table",
  "table-cells-merge",
  "table-cells-split",
  "table-columns-split",
  "table-of-contents",
  "table-properties",
  "table-rows-split",
  "table2",
  "tablet",
  "tablet-smartphone",
  "tablets",
  "tag",
  "tags",
  "tally1",
  "tally2",
  "tally3",
  "tally4",
  "tally5",
  "tangent",
  "target",
  "telescope",
  "tent",
  "tent-tree",
  "terminal",
  "terminal-square",
  "test-tube",
  "test-tube-diagonal",
  "test-tube2",
  "test-tubes",
  "text",
  "text-cursor",
  "text-cursor-input",
  "text-quote",
  "text-search",
  "text-select",
  "text-selection",
  "theater",
  "thermometer",
  "thermometer-snowflake",
  "thermometer-sun",
  "thumbs-down",
  "thumbs-up",
  "ticket",
  "ticket-check",
  "ticket-minus",
  "ticket-percent",
  "ticket-plus",
  "ticket-slash",
  "ticket-x",
  "tickets",
  "tickets-plane",
  "timer",
  "timer-off",
  "timer-reset",
  "toggle-left",
  "toggle-right",
  "toilet",
  "tornado",
  "torus",
  "touchpad",
  "touchpad-off",
  "tower-control",
  "toy-brick",
  "tractor",
  "traffic-cone",
  "train",
  "train-front",
  "train-front-tunnel",
  "train-track",
  "tram-front",
  "trash",
  "trash2",
  "tree-deciduous",
  "tree-palm",
  "tree-pine",
  "trees",
  "trello",
  "trending-down",
  "trending-up",
  "trending-up-down",
  "triangle",
  "triangle-alert",
  "triangle-right",
  "trophy",
  "truck",
  "turtle",
  "tv",
  "tv-minimal",
  "tv-minimal-play",
  "tv2",
  "twitch",
  "twitter",
  "type",
  "type-outline",
  "umbrella",
  "umbrella-off",
  "underline",
  "undo",
  "undo-dot",
  "undo2",
  "unfold-horizontal",
  "unfold-vertical",
  "ungroup",
  "university",
  "unlink",
  "unlink2",
  "unlock",
  "unlock-keyhole",
  "unplug",
  "upload",
  "upload-cloud",
  "usb",
  "user",
  "user-check",
  "user-check2",
  "user-circle",
  "user-circle2",
  "user-cog",
  "user-cog2",
  "user-minus",
  "user-minus2",
  "user-pen",
  "user-plus",
  "user-plus2",
  "user-round",
  "user-round-check",
  "user-round-cog",
  "user-round-minus",
  "user-round-pen",
  "user-round-plus",
  "user-round-search",
  "user-round-x",
  "user-search",
  "user-square",
  "user-square2",
  "user-x",
  "user-x2",
  "user2",
  "users",
  "users-round",
  "users2",
  "utensils",
  "utensils-crossed",
  "utility-pole",
  "variable",
  "vault",
  "vegan",
  "venetian-mask",
  "verified",
  "vibrate",
  "vibrate-off",
  "video",
  "video-off",
  "videotape",
  "view",
  "voicemail",
  "volleyball",
  "volume",
  "volume-off",
  "volume-x",
  "volume1",
  "volume2",
  "vote",
  "wallet",
  "wallet-cards",
  "wallet-minimal",
  "wallet2",
  "wallpaper",
  "wand",
  "wand-sparkles",
  "wand2",
  "warehouse",
  "washing-machine",
  "watch",
  "waves",
  "waves-ladder",
  "waypoints",
  "webcam",
  "webhook",
  "webhook-off",
  "weight",
  "wheat",
  "wheat-off",
  "whole-word",
  "wifi",
  "wifi-high",
  "wifi-low",
  "wifi-off",
  "wifi-zero",
  "wind",
  "wind-arrow-down",
  "wine",
  "wine-off",
  "workflow",
  "worm",
  "wrap-text",
  "wrench",
  "x",
  "x-circle",
  "x-octagon",
  "x-square",
  "youtube",
  "zap",
  "zap-off",
  "zoom-in",
  "zoom-out",
];

// Lucide Lab icons (388 additional icons) - converted from camelCase to kebab-case
const LUCIDE_LAB_ICONS = [
  "ampersand-square",
  "apple-core",
  "arrows-up-down-square",
  "astronaut-helmet",
  "at-sign-circle",
  "at-sign-square",
  "avocado",
  "baby-pacifier",
  "bacon",
  "bag-hand",
  "barbecue",
  "barber-pole",
  "barn",
  "baseball",
  "baseline-square",
  "basketball",
  "bat-ball",
  "bath-bubble",
  "beach-ball",
  "bear-face",
  "bed-bunk",
  "bee",
  "bee-hive",
  "beetle-scarab",
  "bell-concierge",
  "bell-concierge-dot",
  "bell-concierge-off",
  "belt",
  "bold-square",
  "bottle-baby",
  "bottle-champagne",
  "bottle-dispenser",
  "bottle-perfume",
  "bottle-plastic",
  "bottle-spray",
  "bottle-toothbrush-comb",
  "bowl-chopsticks",
  "bowl-overflow",
  "bowling",
  "bra-sports",
  "briefcase-plus",
  "broom",
  "bucket",
  "bull-head",
  "burger",
  "butterfly",
  "cabin",
  "cabinet-filing",
  "cactus",
  "candle-holder",
  "candle-holder-lit",
  "candle-tealight",
  "candle-tealight-lit",
  "candlestick",
  "candlestick-big",
  "candlestick-big-lit",
  "candlestick-lit",
  "card-credit",
  "card-sd",
  "card-sim",
  "carton",
  "carton-off",
  "case-camel",
  "case-kebab",
  "case-snake",
  "case-snake-upper",
  "cat-big",
  "cauldron",
  "cent",
  "cent-circle",
  "cent-square",
  "chairs-table-parasol",
  "chairs-table-platter",
  "chameleon",
  "cheese",
  "chef-hat",
  "chest",
  "chevrons-left-right-square",
  "chevrons-up-down-square",
  "circle-dollar-sign",
  "cloth",
  "coat-hanger",
  "cocktail",
  "coconut",
  "coffee",
  "coffee-bean",
  "coffeemaker",
  "coins-exchange",
  "coins-stack",
  "concierge-bell",
  "copy-code",
  "copy-down",
  "copy-file-path",
  "copy-image",
  "copy-text",
  "copy-type",
  "cow-head",
  "cow-udder-droplets",
  "crab",
  "cricket-ball",
  "cricket-wicket",
  "cross-square",
  "crosshair2",
  "crosshair2-dot",
  "crosshair-plus",
  "crosshair-plus-dot",
  "crosshair-square",
  "cup-saucer",
  "cup-to-go",
  "currency-square",
  "desk-lamp",
  "diaper",
  "dishwasher",
  "dollar-sign-circle",
  "dollar-sign-square",
  "doorbell-intercom",
  "dress",
  "egg-cup",
  "elephant",
  "elephant-face",
  "escalator-arrow-down-left",
  "escalator-arrow-up-right",
  "euro-circle",
  "euro-square",
  "face-alien",
  "fan-handheld",
  "farm",
  "faucet",
  "feather-plus",
  "feather-square",
  "feather-text",
  "flippers",
  "floor-plan",
  "floppy-disk",
  "floppy-disk2",
  "floppy-disk-rear",
  "floppy-disks",
  "floppy-disks2",
  "floppy-disks-rear",
  "flower2",
  "flower-lotus",
  "flower-pot",
  "flower-rose",
  "flower-rose-single",
  "flower-stem",
  "flower-tulip",
  "football",
  "football-goal",
  "football-helmet",
  "fork-knife",
  "fork-knife-crossed",
  "fox-face-tail",
  "frog-face",
  "fruit",
  "garlic",
  "gearbox",
  "gearbox-square",
  "gem-ring",
  "glasses-square",
  "glasses-sun",
  "goal-net",
  "goblet",
  "goblet-crack",
  "golf-driver",
  "grape",
  "grapes",
  "grid-lines",
  "grid-lines-offset",
  "hairdryer",
  "hard-hat",
  "hat-baseball",
  "hat-beanie",
  "hat-bowler",
  "hat-chef",
  "hat-hard",
  "hat-top",
  "heading-circle",
  "heading-square",
  "hedgehog",
  "helmet-diving",
  "hexagons3",
  "hexagons7",
  "high-heel",
  "hockey",
  "hockey-mask",
  "horse-head",
  "hot-dog",
  "house-manor",
  "house-roof",
  "house-roof-off",
  "houses",
  "ice-hockey",
  "ice-skate",
  "igloo",
  "indian-rupee-circle",
  "indian-rupee-square",
  "intercom",
  "iron",
  "iron-off",
  "ironing-board",
  "italic-square",
  "jacket",
  "jacket-sports",
  "japanese-yen-circle",
  "japanese-yen-square",
  "jar",
  "jug",
  "kebab",
  "kettle",
  "kettle-electric",
  "kiwi",
  "layout-grid-move-horizontal",
  "layout-grid-move-vertical",
  "layout-grid-plus",
  "layout-list-move",
  "lemon",
  "life-jacket",
  "ligature-square",
  "light-switch",
  "lingerie",
  "locate-square",
  "luggage-cabin",
  "lunch-box",
  "mailbox-flag",
  "mask-snorkel",
  "meal-box",
  "mortar-pestle",
  "motor-racing-helmet",
  "mug",
  "mug-teabag",
  "mustache",
  "olive",
  "onion",
  "owl",
  "pac-man",
  "pac-man-ghost",
  "palmtree-island-sun",
  "pancakes",
  "peace",
  "peach",
  "pear",
  "penguin",
  "pepper-chilli",
  "pie",
  "pig",
  "pig-head",
  "pillow",
  "pin-safety",
  "pin-safety-open",
  "pineapple-ring",
  "planet",
  "pond",
  "pound-sterling-circle",
  "pound-sterling-square",
  "pram",
  "pretzel",
  "pumpkin",
  "razor",
  "razor-blade",
  "reel-thread",
  "refrigerator-freezer",
  "remove-formatting-square",
  "rugby",
  "russian-ruble-circle",
  "russian-ruble-square",
  "sausage",
  "scarf",
  "scissors-hair-comb",
  "shark",
  "shave-face",
  "shirt-folded-buttons",
  "shirt-long-sleeve",
  "shirt-t",
  "shirt-t-ruler",
  "shirt-t-v-neck",
  "shorts",
  "shorts-boxer",
  "shovel-dig",
  "shower",
  "skirt",
  "skis",
  "slot-card",
  "slot-card-credit",
  "slot-disc",
  "sneaker",
  "snowboard",
  "snowman",
  "soap-bar",
  "soccer-ball",
  "soccer-pitch",
  "socket-eu",
  "socket-uk",
  "socket-usa",
  "socks",
  "spider",
  "spider-web",
  "stairs",
  "stairs-arch",
  "stairs-arrow-down-left",
  "stairs-arrow-up-right",
  "star-north",
  "steering-wheel",
  "strawberry",
  "strikethrough-square",
  "stroller",
  "sunlounger-parasol-sun",
  "sunlounger-parasol-sun-palmtree",
  "sunlounger-parasol-table",
  "surfboard",
  "sushi",
  "sushi2",
  "sushi3",
  "sushi-chopsticks",
  "sweater",
  "swiss-franc-circle",
  "swiss-franc-square",
  "tab",
  "tab-arrow-down",
  "tab-arrow-up-right",
  "tab-check",
  "tab-dot",
  "tab-plus",
  "tab-slash",
  "tab-text",
  "tab-x",
  "target-arrow",
  "tennis-ball",
  "tennis-racket",
  "text-square",
  "tie",
  "tie-bow",
  "tie-bow-ribbon",
  "tire",
  "toast",
  "toaster",
  "toilet-roll",
  "toolbox",
  "toolbox2",
  "top-crop",
  "towel-folded",
  "towel-rack",
  "trees-forest",
  "triangle-stripes",
  "trousers",
  "tuxedo",
  "type-square",
  "ufo",
  "underline-square",
  "unicorn-head",
  "venn",
  "vest",
  "waffle",
  "wardrobe",
  "watch-activity",
  "watch-alarm",
  "watch-bars",
  "watch-charging",
  "watch-check",
  "watch-loader",
  "watch-music",
  "watch-square",
  "watch-square-alarm",
  "watch-text",
  "watermelon",
  "wave-circle",
  "waves-birds",
  "waves-shark-fin",
  "whale",
  "whale-narwhal",
  "wheel",
  "whisk",
  "whisk-fork-knife",
  "whisks",
  "windmill",
  "wine-glass-bottle",
  "yarn-ball",
  "yin-yang",
];

// Combine all icons
const ALL_ICON_NAMES = [...LUCIDE_ICONS, ...LUCIDE_LAB_ICONS];

// Curated popular icons (shown first when no search)
const POPULAR_ICONS = [
  "hexagon",
  "circle",
  "star",
  "home",
  "sun",
  "moon",
  "cloud",
  "cloud-rain",
  "cloud-lightning",
  "wind",
  "tornado",
  "sparkles",
  "flame",
  "droplet",
  "skull",
  "heart",
  "shield",
  "sword",
  "wand",
  "scroll",
  "gem",
  "crown",
  "flag",
  "map-pin",
  "compass",
  "anchor",
  "target",
  "zap",
  "alert-triangle",
  "check-circle",
  "x-circle",
  "mountain",
  "tree-pine",
  "waves",
  "snowflake",
  "thermometer",
  "eye",
  "eye-off",
  "lock",
  "unlock",
  "key",
  "coins",
  "hourglass",
  "clock",
  "calendar",
  "map",
  "navigation",
  "milestone",
  "footprints",
  "paw-print",
  "bird",
  "fish",
  "bug",
  "leaf",
  "flower-2",
  "dices",
  "dice-1",
  "dice-2",
  "dice-3",
  "dice-4",
  "dice-5",
  "dice-6",
  // Lab favorites
  "cauldron",
  "coconut",
  "butterfly",
  "bee",
  "crab",
  "whale",
  "shark",
  "owl",
  "penguin",
  "frog-face",
  "unicorn-head",
  "goblet",
  "chest",
  "football",
  "basketball",
  "soccer-ball",
  "ufo",
  "planet",
];

interface IconPickerModalProps {
  opened: boolean;
  onClose: () => void;
  onSelect: (iconName: string | null) => void;
  currentIcon?: string | null;
}

export function IconPickerModal({ opened, onClose, onSelect, currentIcon }: IconPickerModalProps) {
  const [search, setSearch] = useState("");

  // Filter icons based on search
  const filteredIcons = useMemo(() => {
    const searchLower = search.toLowerCase().trim();

    if (!searchLower) {
      // Return popular icons first, then the rest
      const popularSet = new Set(POPULAR_ICONS);
      const otherIcons = ALL_ICON_NAMES.filter((name: string) => !popularSet.has(name));
      return [...POPULAR_ICONS, ...otherIcons];
    }

    // Search by name
    return ALL_ICON_NAMES.filter((name: string) => name.includes(searchLower));
  }, [search]);

  const handleSelect = (iconName: string) => {
    onSelect(iconName);
    onClose();
  };

  const handleClear = () => {
    onSelect(null);
    onClose();
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Select Icon" size="lg" centered>
      <Stack gap="md">
        <TextInput
          placeholder="Search icons..."
          leftSection={<Search size={16} />}
          value={search}
          onChange={(e) => setSearch(e.currentTarget.value)}
          autoFocus
        />

        {currentIcon && (
          <Group gap="xs">
            <Text size="sm" c="dimmed">
              Current:
            </Text>
            <Badge variant="light" leftSection={<HexIcon icon={currentIcon} size={12} />}>
              {currentIcon}
            </Badge>
            <UnstyledButton onClick={handleClear} className={classes.clearButton}>
              <Text size="xs" c="red">
                Clear
              </Text>
            </UnstyledButton>
          </Group>
        )}

        <Text size="sm" c="dimmed">
          {filteredIcons.length} icons {search && `matching "${search}"`}
        </Text>

        <ScrollArea h={400} offsetScrollbars>
          <SimpleGrid cols={6} spacing="xs">
            {filteredIcons.slice(0, 200).map((iconName: string) => {
              const isSelected = currentIcon === iconName;

              return (
                <UnstyledButton
                  key={iconName}
                  className={`${classes.iconButton} ${isSelected ? classes.selected : ""}`}
                  onClick={() => handleSelect(iconName)}
                  title={iconName}
                >
                  <HexIcon icon={iconName} size={24} />
                  <Text size="xs" className={classes.iconLabel} lineClamp={1}>
                    {iconName}
                  </Text>
                </UnstyledButton>
              );
            })}
          </SimpleGrid>
          {filteredIcons.length > 200 && (
            <Text size="sm" c="dimmed" ta="center" mt="md">
              Showing first 200 of {filteredIcons.length} icons. Refine your search to see more.
            </Text>
          )}
        </ScrollArea>
      </Stack>
    </Modal>
  );
}

export default IconPickerModal;
